import React, { useContext } from "react";
import { LoginOtpContext } from "../LoginOtpView";
import Button from "../../../../../components/ButtonComponent/Button";
import OtpInput from "react18-input-otp";
import Arrow from "../../../../../assests/images/backArrow.svg";
import AlertBox from "../../../../../components/alertComponent/AlertBox";
import "./LoginEnterOtp.css";
import Spinner from "../../../../../components/spinner/Spinner";

const EnterLoginOtp = ({ textContents }) => {
  const {
    otp,
    handleChange,
    loginOnSubmit,
    goBack,
    showAlert,
    setShowAlert,
    alertMessage,
    onSubmitClik,
    otpTimeOut,
    apiStatus
  } = useContext(LoginOtpContext);

  return (
    <>
      <div
        className="backArrow"
        onClick={() => {
          goBack();
        }}
      >
        <img src={Arrow} />
      </div>
      <div className="loginContainer">
        <div className="col-xl-4 col-lg-5 col-md-5 col-sm-6 col-10 mainBoxEnterOtp">
        { apiStatus === 'fetching'  ? <Spinner /> : null}
          <p class="text1 ">{textContents.enterOtp}</p>
          <form class="form-otp">
            <div className="otp-mob-div">
              <OtpInput
                value={otp}
                onChange={(number) => {
                  handleChange(number);
                }}
                numInputs={6}
                onSubmit={(number) => {
                  handleChange(number);
                }}
                autoComplete={true}
                isInputNum={true}
              />
            </div>
            <p className="mt-3 ">
              <span className="textLight">
                {textContents.didntRecieveTheCode}  { otpTimeOut ?  `try again in ${otpTimeOut} seconds` : null }
              </span>
              <span class="resendOtp" onClick={() => onSubmitClik()}>
                {textContents.resend}
              </span>
            </p>
          </form>
          <div className="buttonContainerOtp">
            <Button
              text={textContents.submit}
              onClick={() => loginOnSubmit(otp)}
            ></Button>
          </div>
        </div>
      </div>
      <AlertBox
        show={showAlert}
        setShow={setShowAlert}
        title={textContents.alert}
        alertMessage={alertMessage}
      />
    </>
  );
};

export default EnterLoginOtp;
